export default __webpack_public_path__ + "static/ad-ad7b28b8809b2680a778487cf7f6a148.svg";